import SourceTrimAccessCode from '../sections/sourceTrimAccess/SourceTrimAccessCode';
import { useAdminToast } from '../shell/AdminToastContext';

export const ClaveCotizadorPage = () => {
    const toast = useAdminToast();
    return <SourceTrimAccessCode toast={toast} />;
};

export default ClaveCotizadorPage;
